import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😤',
  text: 'Meltdowns over small things that leave everyone exhausted'
}, {
  emoji: '😶',
  text: 'Your child struggles to say what they feel, so they act out instead'
}, {
  emoji: '😰',
  text: "You've tried talking about feelings, but nothing seems to stick"
}, {
  emoji: '💔',
  text: 'Bedtime battles, sibling fights, and emotional shutdowns'
}];
export function PainPoints() {
  return <section className="py-20 bg-lavender relative" data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-dark mb-4" data-id="element-243">
            Does This Sound Familiar?
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-244">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-6 shadow-sm hover:shadow-md transition-shadow border border-white/50" data-id="element-245">
              <div className="text-4xl mb-4 bg-lavender/50 w-16 h-16 rounded-2xl flex items-center justify-center" data-id="element-246">
                {point.emoji}
              </div>
              <p className="text-dark font-medium leading-relaxed" data-id="element-247">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="max-w-3xl mx-auto text-center" data-id="element-248">
          <p className="text-xl md:text-2xl text-dark font-heading font-semibold leading-relaxed" data-id="element-249">
            You're not alone. And it's not your fault.{' '}
            <br className="hidden md:block" data-id="element-250" />
            <span className="text-primary" data-id="element-251">
              Children aren't born knowing how to handle big emotions — but they
              CAN learn.
            </span>
          </p>
        </motion.div>
      </div>

      {/* Bottom Wave Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180 translate-y-[99%] z-10" data-id="element-252">
        <svg className="relative block w-full h-[40px] sm:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-253">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-cream" data-id="element-254"></path>
        </svg>
      </div>
    </section>;
}